import { createContext, useContext } from "react";
import {
	DEFAULT_VERITY_INSTITUTE_SETTINGS,
	EditQuizType,
	ExemptedStudent,
	VerityInstituteSettings,
} from "../../types/common";
import { OptionRelatedInstituteSettings, ProctoringOption } from "@verity/proctoring-option/types";
import { EnabledProctoringOptions } from "@verity/api-client/types";
import { DEFAULT_ENABLED_PROCTORING_CONFIGURATION_VALUES, DEFAULT_PROCTORING_OPTION } from "@verity/proctoring-option";
import type { ReferenceMaterialType } from "../hooks/state/useSettingsState";

export const StandAloneExemptedStudentsContext = createContext<{
	studentList: { name: string; userId: number }[];
	exemptedStudents: ExemptedStudent[];
	isCreating?: boolean;
}>({ studentList: [], exemptedStudents: [] });

const PROCTORING_OPTION_CONTEXT_DEFAULTS = {
	enforcedProfilesOnly: false,
	isThirdPartyEnabled: false,
	optionRelatedInstituteSettings: undefined,
	proctoringOption: DEFAULT_PROCTORING_OPTION,
	setProctoringOption: () => {},
	verityInstituteSettings: DEFAULT_VERITY_INSTITUTE_SETTINGS,
	enabledProctoringOptions: DEFAULT_ENABLED_PROCTORING_CONFIGURATION_VALUES,
	isMobileLayout: false,
	quizType: undefined,
};

export const ProctoringOptionContext = createContext<{
	proctoringOption: Partial<ProctoringOption>;
	setProctoringOption: (options: Partial<ProctoringOption>) => void;
	verityInstituteSettings: VerityInstituteSettings;
	enforcedProfilesOnly: boolean;
	isThirdPartyEnabled: boolean;
	optionRelatedInstituteSettings: OptionRelatedInstituteSettings | undefined;
	enabledProctoringOptions: EnabledProctoringOptions;
	isMobileLayout: boolean;
	quizType?: EditQuizType;
	referenceMaterialFiles?: ReferenceMaterialType[];
	onUpdateReferenceMaterialFiles?: (files: ReferenceMaterialType[]) => void;
	/** Shows the reference material enable/disable toggle without file upload (e.g. profile flows with no quiz to attach a file to). */
	referenceMaterialToggleOnly?: boolean;
}>(PROCTORING_OPTION_CONTEXT_DEFAULTS);

export const useProctoringOptionContext = () => useContext(ProctoringOptionContext);

export const EditQuizToastContext = createContext<string | undefined>(undefined);
export const useEditQuizToast = () => useContext(EditQuizToastContext);
